export const MAX_MENU_NOVEDADES = 8;

export function normalizeMenuNovedadesFromApi(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((item) => item && item.id && item.image_url)
    .map((item, index) => ({
      id: String(item.id),
      title: String(item.title || '').trim().slice(0, 80),
      image_url: String(item.image_url || '').trim(),
      link_url: String(item.link_url || '').trim(),
      is_active: item.is_active !== false,
      display_order: Number.isFinite(Number(item.display_order)) ? Number(item.display_order) : index,
    }))
    .sort((a, b) => a.display_order - b.display_order);
}

export function activePublicMenuNovedades(items) {
  return normalizeMenuNovedadesFromApi(items).filter((item) => item.is_active && item.image_url);
}

export function createEmptyMenuNovedad(displayOrder = 0) {
  return {
    id: `novedad-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    title: '',
    image_url: '',
    link_url: '',
    is_active: true,
    display_order: displayOrder,
  };
}

export function reorderMenuNovedades(items, id, direction) {
  const list = [...normalizeMenuNovedadesFromApi(items)];
  const index = list.findIndex((item) => item.id === id);
  if (index < 0) return list;
  const target = direction === 'up' ? index - 1 : index + 1;
  if (target < 0 || target >= list.length) return list;
  const next = [...list];
  [next[index], next[target]] = [next[target], next[index]];
  return next.map((item, idx) => ({ ...item, display_order: idx }));
}

export function menuNovedadesSavePayload(items) {
  return normalizeMenuNovedadesFromApi(items)
    .slice(0, MAX_MENU_NOVEDADES)
    .map((item, index) => ({
      id: item.id,
      title: item.title,
      image_url: item.image_url,
      link_url: item.link_url || null,
      is_active: item.is_active !== false,
      display_order: index,
    }));
}
